/**
 * roll
 */

import Component, { nextTick, subscribe } from "../../js/lib/component";
import Swiper from "swiper";
import $ from "jquery";
import anime from "animejs";

const classList = {
  root: ".js-roll",
  body: ".js-roll-body",
  swiper: ".js-roll-swiper",
  list: ".js-roll-list",
  item: ".js-roll-item",
  prev: ".js-roll-prev",
  next: ".js-roll-next"
};

export default class Roll extends Component {
  init() {
    this.options = Object.assign(
      {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 30,
        speed: 1000,
        wrapperClass: classList.list.substr(1),
        slideClass: classList.item.substr(1),
        navigation: {
          prevEl: this.$.prev.get(0),
          nextEl: this.$.next.get(0)
        },
        on: {
          init: () => {
            this.show();
          }
        }
      },
      this.$.root.data("options")
    );

    this.Switch = this.childs("Switches")._one();

    if (this.Switch) {
      this.state.currentType = this.Switch.state.type;
      this.state.$currentItems = this.filterItems(this.state.currentType);
    } else {
      this.state.currentType = "all";
      this.state.$currentItems = this.$.item;
    }

    nextTick().then(() => {
      this.setState({
        height: this.$.list.outerHeight()
      });
      this.renderItems();
      this.updateHeight(true);
      this.initSwiper();
    });
  }
  events() {
    if (this.Switch) {
      this.Switch.$.root.on("switches:change", (e, { type }) => {
        if (this.state.init) {
          this.state.currentType = type;
          this.state.$currentItems = this.filterItems(this.state.currentType);
          this.render();
        }
      });
    }
    subscribe("page:resize", () => this.updateHeight(true));
  }
  filterItems(type) {
    return type && type !== "all"
      ? this.$.item.filter((i, item) => $(item).data("type") === type)
      : this.$.item;
  }
  render() {
    this.hide().then(() => {
      this.destroySwiper();
      this.renderItems();
      this.updateHeight();
      this.initSwiper();
    });
  }
  renderItems() {
    this.$.list.html(this.state.$currentItems);
  }
  showControls() {
    if (this.state.$currentItems.length > this.options.slidesPerView) {
      this.$.prev.addClass("is-visible");
      this.$.next.addClass("is-visible");
    }
  }
  destroySwiper() {
    this.swiper.destroy(true, true);
  }
  initSwiper() {
    this.showControls();
    this.swiper = new Swiper(this.$.swiper.get(0), this.options);
  }
  hide() {
    return new Promise(resolve => {
      this.state.init = false;

      anime({
        targets: this.$.item.get(),
        opacity: 0,
        easing: "easeOutCubic",
        duration: 200,
        complete: () => {
          this.$.root.removeClass("is-inited");
          resolve();
        }
      });
    });
  }
  show() {
    const targets = this.state.$currentItems.get();

    anime.set(targets, {
      opacity: 0,
      translateY: 30
    });

    if (this.Switch) {
      this.Switch.toggle();
    }

    this.$.root.addClass("is-inited");

    anime({
      targets,
      opacity: 1,
      translateY: 0,
      easing: "easeOutCubic",
      duration: 200,
      delay: anime.stagger(50),
      complete: () => {
        this.state.init = true;
      }
    });
  }
  updateHeight(force) {
    return nextTick(0).then(() => {
      const height = this.$.list.outerHeight();

      this.$.body.css("height", this.state.height);
      this.setState({ height });

      if (force) {
        anime.set(this.$.body.get(0), {
          height
        });
      } else {
        return anime({
          targets: this.$.body.get(0),
          duration: 300,
          easing: "easeOutCubic",
          height
        }).finished;
      }
    });
  }
}

Component.mount(Roll, {
  name: "Roll",
  state: {
    init: false,
    height: 0,
    currentType: "",
    $currentItems: null
  },
  classList
});
